import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";

export const useBuildStandings = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { sport, organizationId, seasonId } = useParams();

  return useMutation<DefaultOperationSuccessResponse, Error>({
    mutationFn: async () => {
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/standings?forceDelete=true`, {
        method: "DELETE",
      });
      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/standings/build`, { method: "POST" });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (isDefaultOperationSucceeded(response)) {
        await queryClient.invalidateQueries({
          queryKey: ["standing-configuration", sport, organizationId, seasonId],
        });
        await queryClient.invalidateQueries({
          queryKey: ["standings", sport, organizationId, seasonId],
        });
      }
    },
  });
};
